import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { authApi } from '@modules/auth/api/auth.api';
import { authUtils } from '@shared/utils/axios-instance';
import { Alert, Button, ControlledInput } from '@shared/ui';
import logoMark from '../../assets/logo-mark.png';
import './LoginPage.css';

interface LoginFormData {
  email: string;
  password: string;
}

const loginSchema = yup.object({
  email: yup
    .string()
    .required('Email обязателен')
    .email('Некорректный email'),
  password: yup
    .string()
    .required('Пароль обязателен')
    .min(6, 'Пароль должен быть не менее 6 символов'),
});

export default function LoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormData>({
    resolver: yupResolver(loginSchema),
    defaultValues: {
      email: 'admin@mail.com',
      password: 'admin123',
    },
  });

  const onSubmit = async (data: LoginFormData) => {
    setLoading(true);
    setError(null);

    try {
      const response = await authApi.login(data);

      authUtils.setAccessToken(response.access_token);
      localStorage.setItem('luxus_admin', JSON.stringify(response.admin));

      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Ошибка входа. Проверьте email и пароль.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <header className="admin-login__top">
        <div className="admin-login__brand">
          <img src={logoMark} alt="" className="admin-login__mark" />
          <span className="admin-login__brand-name">Лавка цветов</span>
        </div>
      </header>

      <main className="admin-login__body">
        <div className="admin-login__card">
          <p className="admin-login__eyebrow">Добро пожаловать</p>
          <h1 className="admin-login__title">Вход в админ-панель</h1>
          <p className="admin-login__subtitle">Введите email и пароль</p>

          {error ? (
            <Alert tone="error" mb="md">
              {error}
            </Alert>
          ) : null}

          <form className="admin-login__form" onSubmit={handleSubmit(onSubmit)}>
            <ControlledInput
              name="email"
              control={control}
              error={errors.email}
              label="Email"
              placeholder="your@email.com"
              type="email"
              autoComplete="email"
            />

            <ControlledInput
              name="password"
              control={control}
              error={errors.password}
              label="Пароль"
              placeholder="Ваш пароль"
              type="password"
              autoComplete="current-password"
            />

            <Button type="submit" variant="primary" fullWidth loading={loading}>
              Войти
            </Button>
          </form>
        </div>
      </main>
    </div>
  );
}
